require('../../modules/es.array.copy-within');

module.exports = require('../../internals/entry-unbind')('Array', 'copyWithin');
